import React, { ReactNode } from "react";
import { useAuth } from "../../auth/useAuth";

interface AdminOnlyProps {
  children: ReactNode;
}

const AdminOnly: React.FC<AdminOnlyProps> = ({ children }) => {
  const { userProfile } = useAuth();

  if (!userProfile || userProfile.role !== "admin") {
    return null;
  }

  return <>{children}</>;
};

export default AdminOnly;
